import { Button, Flex, FormControl, FormErrorMessage, FormLabel, Grid, HStack, Input, Select, useToast } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
// import InputMask from "react-input-mask";
import { yupResolver } from "@hookform/resolvers/yup";

import Layout from 'components/ManagerLayout'
import FormCard from 'components/FormCard'
import { useCreateUser } from 'hooks/useUsers'
import sanitizeForm from 'functions/sanitizeForm';
import schema from './userFormSchema';
import { isEmpty } from 'lodash';

interface FormData {
    name: string
    email: string
    role_id: string
}

const CreateUser = () => {
    const navigate = useNavigate();

    const methods = useForm<FormData>({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        resolver: yupResolver(schema)
    });
    const toast = useToast();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;

    const [createUser, { loading }] = useCreateUser({
        onSuccess: (data: any) => {
            toast({
                title: 'Usuário cadastrado com sucesso.',
                status: 'success',
                duration: 5000,
                isClosable: true
            });
            navigate('./..');
            // navigate('../administracao/usuarios/' + data.id);
        },
        onError: (err: any) => {
            const graphqQlErrors = err.graphQLErrors;
            console.log("ERROR", err, graphqQlErrors)
            
            if(!graphqQlErrors){
                toast({
                    title: 'Ocorreu um erro',
                    status: 'error',
                    duration: 5000,
                    isClosable: true
                });
                return;
            }

            if(graphqQlErrors[0].message == "Validation failed for the field [createUser].") {
                toast({
                    title: 'E-mail ja esta cadastrado',
                    status: 'error',
                    duration: 5000,
                    isClosable: true
                });
            }
        }
    });

    const onSubmit = (data: any) => {
        const formData = sanitizeForm(data);

        const variables = {
            input: {
                ...formData
            }
        }

        createUser({ variables });
    };


    return (
        <Layout>
            <FormCard title="Cadastrar Usuário">
                <FormProvider {...methods}>
                    <form
                        style={{ width: '100%' }}
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Flex direction="column" w="100%">
                            <Grid
                                w="full"
                                templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}
                                gap="24px"
                                mb="24px"
                            >
                                <FormControl isInvalid={!isEmpty(errors.name)}>
                                    <FormLabel
                                        fontWeight="bold"
                                        fontSize="xs"
                                    >
                                        Nome completo
                                    </FormLabel>
                                    <Input
                                        {...register("name")}
                                        borderRadius="8px"
                                        fontSize="md"
                                    />
                                    <FormErrorMessage>
                                        {errors.name?.message}
                                    </FormErrorMessage>
                                </FormControl>
                                <FormControl isInvalid={!isEmpty(errors.email)}>
                                    <FormLabel
                                        fontWeight="bold"
                                        fontSize="xs"
                                    >
                                        E-mail
                                    </FormLabel>
                                    <Input
                                        {...register("email")}
                                        borderRadius="8px"
                                        fontSize="md"
                                    />
                                    <FormErrorMessage>
                                        {errors.email?.message}
                                    </FormErrorMessage>
                                </FormControl>
                                <FormControl isInvalid={!isEmpty(errors.role_id)}>
                                    <FormLabel
                                        fontWeight="bold"
                                        fontSize="xs"
                                    >
                                        Tipo de Usuário
                                    </FormLabel>
                                    <Select
                                        placeholder="Seleciona uma opção"
                                        {...register("role_id")}
                                    >
                                        {/* <option value="1">Super Admin</option> */}
                                        <option value="2">Administrador</option>
                                        <option value="3">Operador</option>
                                    </Select>
                                    <FormErrorMessage>
                                        {errors.role_id?.message}
                                    </FormErrorMessage>
                                </FormControl>
                            </Grid>
                            <Flex w="full" justifyContent="flex-end">
                                <HStack spacing={4}>
                                    <Button
                                        onClick={() => navigate('./..')}
                                        disabled={loading}
                                        variant="ghost"
                                        colorScheme="gray"
                                        size="md"
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        type="submit"
                                        isLoading={loading}
                                        disabled={loading}
                                        colorScheme="green"
                                    >
                                        Cadastrar
                                    </Button>
                                </HStack>
                            </Flex>
                        </Flex>
                    </form>
                </FormProvider>
            </FormCard>
        </Layout>
    )
}

export default CreateUser